export function transformApiValidation(data) {
  if (data.message) return [{ message: data.message }];

  if (data.messages) return data.messages;
}
